//const DOMAIN = 'https://dev.public.api.mindkindbeta.com';
const DOMAIN =
  'https://05y62vgjif.execute-api.us-east-1.amazonaws.com/workskills-public-dev';
//const DOMAIN = 'https://z537pg042a.execute-api.us-east-1.amazonaws.com';

export const environment = {
  // Config
  environmentName: 'dev',
  autoSignOutTime : 60,
  region: 'us-east-1',
  production: true,
  loggingEnabled: true,
  analyticsTrackingEnabled: true,
  oauth: {//@RG - change to apprize oauth dev details
    domain: 'sff-apprize-dev.auth.us-east-1.amazoncognito.com', 
    redirectSignIn: 'https://d21c757ji2852n.cloudfront.net/sso-redirect',
    redirectSignOut: 'https://d21c757ji2852n.cloudfront.net/sso-signout',
    responseType: 'code',
    scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
  },
  //'baseHostname': 'dev.mindkindbeta.com',
  baseHostname: 'd21c757ji2852n.cloudfront.net',
  //'redirectURI': 'https://dev.mindkindbeta.com/on-boarding/start',
  redirectURI: 'https://d21c757ji2852n.cloudfront.net/on-boarding/start',
  userPoolID: 'us-east-1_8I537GYsi',
  clientID: '432phrtlib86gmgj9ke4a9v8b6',

  // Profile
  profileAPI: DOMAIN + '/profile',
  dashboardAPI: DOMAIN + '/dashboard',
  learnerCareerAPI: DOMAIN + '/insertLearnerCareer', // to delete
  ndaAPI: DOMAIN + '/profile/nda', // to delete

  // Assessments
  assessmentAPI: DOMAIN + '/assessments',
  sneAnswerAPI: DOMAIN + '/assessments/answer',
  cipAPI: DOMAIN + '/assessments/cip',
  facetsAPI: DOMAIN + '/assessments/facets',
  sneNegotiationAPI: DOMAIN + '/assessments/sne/negotiation',
  sneScoreAPI: `${DOMAIN}/assessments/sne/score`,

  // Applied Signals
  stepAPI: DOMAIN + '/match',
  workHistoryAPI: `${DOMAIN}/match/work-history`,
  deleteWorkHistoryAPI: DOMAIN + '/match/work-history/delete',
  skillsAPI: DOMAIN + '/match/skills',
  educationHistoryAPI: DOMAIN + '/match/education-history',
  trainingsAPI: DOMAIN + '/match/trainings',
  trainingApplicationAPI: DOMAIN + '/match/application',
  fileManagerAPI: `${DOMAIN}/match/file-manager`,
  careerChoicesAPI: DOMAIN + '/match/career-choices',
  careerDetailsAPI: DOMAIN + '/match/career-details',
  bgtAPI: DOMAIN + '/bgt',

  // Logging
  logAPI: DOMAIN + '/log',
  eventAPI: 'https://v8dn993b95.execute-api.us-east-1.amazonaws.com/event', //DOMAIN + '/event',
};

//v1 - archived
// 'careerDetailsAPI': DOMAIN + '/careerdetails',
// 'bgAPI': DOMAIN + '/match/bgt',
// 'careerPrioritizationAPI': DOMAIN + '/career/prioritization',
// 'workHistoryAPI': `${DOMAIN}/getWorkHistory`,
// 'deleteRole': DOMAIN + '/match/delete-work-history'
// 'applyToTraining': DOMAIN + '/applyToTraining',
// 'fileManagerAPI': `${DOMAIN}/fileManager`,
// 'updateSkillsAPI': DOMAIN + '/step/updateSkillProficiency',
// 'bgAPI': DOMAIN + '/bgt',
// 'stepAPI': DOMAIN + '/step',
// 'skillsAPI': DOMAIN + '/skills',
// 'sneGenerateScoreAPI': `${DOMAIN}/sne/generateScore`,
// 'negotiationAPI': DOMAIN + '/negotiation',
// 'sneAnswerAPI': DOMAIN + '/sne/cpsAnswer',
// 'educationHistoryAPI': DOMAIN + '/fieldOfStudy',
